export const SNACKBAR_AUTOHIDE_DURATION = 6000;
